import { AxiosError } from 'axios'

interface ApiErrorResponse {
  detail?: string
  message?: string
  error?: string
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined
    return data?.detail || data?.message || data?.error || error.message || 'An error occurred'
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  return 'An unexpected error occurred'
}
